import { ArrowLeft, ArrowRight } from "lucide-react";

const Label = ({ children }) => (
  <label className="block text-xs uppercase tracking-[0.15em] font-bold mb-1.5" style={{ fontFamily: 'Outfit, sans-serif', color: 'var(--text-secondary)' }}>{children}</label>
);
const Input = (props) => <input className="brutalist-input" {...props} />;

export default function ThreeCircuitStep2({ formData, updateForm, onNext, onPrev }) {
  const circuits = formData.circuits || [{}, {}, {}];

  const updateCircuit = (idx, field, value) => {
    const updated = circuits.map((c, i) => (i === idx ? { ...c, [field]: value } : c));
    updateForm({ circuits: updated });
  };

  return (
    <div className="form-container max-w-4xl mx-auto" data-testid="tcmw-step-2">
      <h2 className="text-xl font-bold mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>Circuit Details & Test Results</h2>

      {[0, 1, 2].map((idx) => {
        const c = circuits[idx] || {};
        const upd = (f) => (e) => updateCircuit(idx, f, e.target.value);
        return (
          <div key={idx} className="border-b-2 pb-5 mb-5" style={{ borderColor: 'var(--border-light)' }}
            data-testid={`tcmw-circuit-${idx}`}>
            <h3 className="text-sm font-bold text-[#00A3E0] uppercase tracking-[0.15em] mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Circuit {idx + 1}
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-2">
              <div className="form-field"><Label>DB ref</Label><Input value={c.db_ref} onChange={upd("db_ref")} /></div>
              <div className="form-field"><Label>Circuit no.</Label><Input value={c.circuit_number} onChange={upd("circuit_number")} /></div>
              <div className="col-span-2"><Label>Description</Label><Input value={c.circuit_description} onChange={upd("circuit_description")} placeholder="e.g. Ring final — sockets" /></div>
            </div>
            <div className="grid grid-cols-3 sm:grid-cols-6 gap-2 mb-2">
              <div className="form-field"><Label>Live (mm²)</Label><Input value={c.conductor_live_size} onChange={upd("conductor_live_size")} /></div>
              <div className="form-field"><Label>CPC (mm²)</Label><Input value={c.conductor_cpc_size} onChange={upd("conductor_cpc_size")} /></div>
              <div className="form-field"><Label>OCPD type</Label><Input value={c.ocpd_type} onChange={upd("ocpd_type")} placeholder="e.g. B" /></div>
              <div className="form-field"><Label>OCPD (A)</Label><Input value={c.ocpd_rating} onChange={upd("ocpd_rating")} /></div>
              <div className="form-field"><Label>RCD type</Label><Input value={c.rcd_type} onChange={upd("rcd_type")} /></div>
              <div className="form-field"><Label>RCD IΔn</Label><Input value={c.rcd_idn} onChange={upd("rcd_idn")} /></div>
            </div>
            <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
              <div className="form-field"><Label>R1+R2 (Ω)</Label><Input value={c.r1r2} onChange={upd("r1r2")} /></div>
              <div className="form-field"><Label>Max Zs (Ω)</Label><Input value={c.max_zs} onChange={upd("max_zs")} /></div>
              <div className="form-field"><Label>IR (V)</Label><Input value={c.ir_test_voltage} onChange={upd("ir_test_voltage")} /></div>
              <div className="form-field"><Label>IR L-E</Label><Input value={c.ir_live_earth} onChange={upd("ir_live_earth")} /></div>
              <div className="form-field">
                <Label>Polarity</Label>
                <select className="brutalist-input" value={c.polarity} onChange={upd("polarity")}>
                  <option value="N/A">N/A</option><option value="Pass">Pass</option><option value="Fail">Fail</option>
                </select>
              </div>
              <div className="form-field"><Label>RCD (ms)</Label><Input value={c.rcd_disconnect_time} onChange={upd("rcd_disconnect_time")} /></div>
            </div>
          </div>
        );
      })}

      <div className="flex justify-between">
        <button onClick={onPrev} className="brutalist-btn-outline flex items-center gap-2"><ArrowLeft className="w-4 h-4" /> Previous</button>
        <button data-testid="tcmw-step-2-next" onClick={onNext} className="brutalist-btn flex items-center gap-2">Next <ArrowRight className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
